/* eslint-disable */
import request from './helpers'

export function listAlarmRule (size, page) {
    return request({
        url: '/api/v1/monitor/alarm/rule/query',
        method: 'get',
        params: {
            size,
            page
        }
    })
}

export function getAlarmRuleById (id) {
    return request({
        url: '/api/v1/monitor/alarm/rule/' + id,
        method: 'get'
    })
}

export function listMetrics () {
    return request({
        url: '/api/v1/monitor/metrics/list',
        method: 'get'
    })
}

export function listFields (metrics) {
    return request({
        url: '/api/v1/monitor/metrics/' + metrics + '/field/list',
        method: 'get'
    })
}

export function listTags (metrics) {
    return request({
        url: '/api/v1/monitor/metrics/' + metrics + '/tag/list',
        method: 'get'
    })
}

export function listTagValues (metrics, tag) {
    return request({
        url: '/api/v1/monitor/metrics/' + metrics + '/tag/' + tag + '/value/list',
        method: 'get'
    })
}

export function deleteAlarmRule (id) {
    return request({
        url: '/api/v1/monitor/alarm/rule/' + id,
        method: 'delete'
    })
}

export function createAlarmRule (data) {
    return request({
        url: '/api/v1/monitor/alarm/rule/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateAlarmRule (id, data) {
    return request({
        url: '/api/v1/monitor/alarm/rule/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateAlarmRuleStatus (id, data) {
    return request({
        url: '/api/v1/monitor/alarm/rule/status/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function listNotificationChannel () {
    return request({
        url: '/api/v1/monitor/channel/list',
        method: 'get'
    })
}

export function getNotificationChannelById (id) {
    return request({
        url: '/api/v1/monitor/channel/' + id,
        method: 'get'
    })
}

export function deleteNotificationChannel (id) {
    return request({
        url: '/api/v1/monitor/channel/' + id,
        method: 'delete'
    })
}

export function createNotificationChannel (data) {
    return request({
        url: '/api/v1/monitor/channel/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateNotificationChannel (id, data) {
    return request({
        url: '/api/v1/monitor/channel/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateNotificationChannelStatus (id, data) {
    return request({
        url: '/api/v1/monitor/channel/status/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function listAllNotificationRule () {
    return request({
        url: '/api/v1/monitor/notification/rule/list',
        method: 'get'
    })
}

export function listNotificationRule (size, page) {
    return request({
        url: '/api/v1/monitor/notification/rule/query',
        method: 'get',
        params: {
            size,
            page
        }
    })
}

export function getNotificationRuleById (id) {
    return request({
        url: '/api/v1/monitor/notification/rule/' + id,
        method: 'get'
    })
}

export function deleteNotificationRule (id) {
    return request({
        url: '/api/v1/monitor/notification/rule/' + id,
        method: 'delete'
    })
}

export function createNotificationRule (data) {
    return request({
        url: '/api/v1/monitor/notification/rule/create',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateNotificationRule (id, data) {
    return request({
        url: '/api/v1/monitor/notification/rule/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateNotificationRuleStatus (id, data) {
    return request({
        url: '/api/v1/monitor/notification/rule/status/' + id,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function listRecord (params) {
    return request({
        url: '/api/v1/monitor/alarm/record/query',
        method: 'get',
        params
    })
}
